import Analytics from 'utils/analytics';
import { makeSelectLang } from 'data/config/runtime-config-selectors';

/**
 *
 * @desc Tracking utility
 *
 */
const PLAYBACK_PAGE = 'Video Playback Page';
const LANDING_PAGE = 'Video Landing Page';
const SEARCH_PAGE = 'Multimedia Search';
const PLAYBACK_HEADER = 'Video Playback Header';

class Tracking {

    static trackLandingPageView() {
        const trackingData = {
            pageName: `${LANDING_PAGE}`
        };

        Analytics.trackPageView(trackingData);
    }

    static trackSearchPageView(config) {
        const { query = ''} = config;
        const baseText = `${SEARCH_PAGE}: ${query}`;
        const trackingData = {
            pageName: baseText
        };

        Analytics.trackPageView(trackingData);
    }

    static trackPlaybackPageView(clipData, topicTitle) {
        const trackingData = {
            pageName: `${PLAYBACK_PAGE}`,
            clipData: clipData || {},
            topicTitle
        };

        Analytics.trackPageView(trackingData);
    }

    static trackLandingPageOnItemClick(e, itemIndex) {
        const baseText = `${PLAYBACK_PAGE} Module Landing Page`;
        const trackingData = {
            prop12: baseText,
            prop14: `${baseText}: Thumbnail ${itemIndex} Click`,
            eVar72: e.currentTarget.href,
        };

        Analytics.track(trackingData);
    }


    static trackSearchPageOnItemClick(e, itemIndex) {
        const baseText = `${PLAYBACK_PAGE} Module Search Results`;
        const trackingData = {
            prop12: baseText,
            prop14: `${baseText}: Thumbnail ${itemIndex} Click`,
            eVar72: e.currentTarget.href,
        };

        Analytics.track(trackingData);
    }

    static onSubNavItemClick(e, itemIndex) {

        const subNavItemText = e.currentTarget.innerText;

        const trackingData = {
            prop12: `${PLAYBACK_HEADER}`,
            prop14: `${PLAYBACK_HEADER}: More Channels: Slot #${itemIndex}: ${subNavItemText}`,
            eVar72: e.currentTarget.href,
        };

        Analytics.track(trackingData);

    };

    static onSubNavDropDownClick(e) {

        const trackingData = {
            prop12: PLAYBACK_HEADER,
            prop14: `${PLAYBACK_HEADER}: More Channels`,
        };

        Analytics.track(trackingData);

    };

    static onShare = (type) => {

        Analytics.track({
            prop14: `Video Page Playback Module: Share Click: ${type} Click`,
        });
    }

    static onMetadataToggle = () => {

        Analytics.track({
            prop12: `${PLAYBACK_PAGE} Module`,
            prop14: `${PLAYBACK_PAGE} Module: Expand Description`,
        });

    }

    static onSearchInputClick = () => {
        Analytics.track({
            prop14: `${PLAYBACK_PAGE} Module: Search: Click`,
        });
    }

    static onPlaylistItemClick = (index, playlist, url) => {

        Analytics.track({
            prop12: `${PLAYBACK_PAGE} Module Featured Playlist`,
            prop14: `${PLAYBACK_PAGE} Module: Featured Playlist ${playlist}: Thumbnail ${index} Click`,
            eVar72: url,
        });
    }

    static onSearchTagClick = (query, url) => {

        Analytics.track({
            prop12: `${PLAYBACK_PAGE} Module: Search: Click`,
            prop14: `${PLAYBACK_PAGE} Module: Search: Click "${query}"`,
            eVar72: url,
        });
    }
};

export default Tracking
